import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import _ from 'lodash'

import { BuildHeader } from 'src/Utils/headerBuilder'
import { RequestMethods } from '../Helper/FetchHelpers'

const initialState = () => {
  return {
    Templates: [],
    EmptyTemplate: [],
  }
}

export const GetTemplateDesigns = createAsyncThunk('GetTemplateDesigns', async () => {
  var requestOptions = {
    method: RequestMethods.GET,
    headers: BuildHeader(),
  }
  const response = await fetch(
    window.extended.MYAPP_API_ENDPOINT + '/Template/getall',
    requestOptions,
  )
  return await response.json()
})

export const UpdateTemplateDesign = createAsyncThunk(
  'UpdateTemplateDesign',
  async (template, { rejectWithValue }) => {
    delete template.HtmlContent

    var raw = JSON.stringify(template)
    var requestOptions = {
      method: RequestMethods.PUT,
      headers: BuildHeader(),
      body: raw,
    }

    const response = await fetch(
      window.extended.MYAPP_API_ENDPOINT + '/Template/update',
      requestOptions,
    )
    if (!response.ok) {
      return rejectWithValue(await response.text())
    }
    return await response.json()
  },
)

export const InsertTemplateDesign = createAsyncThunk(
  'InsertTemplateDesign',
  async (template, { rejectWithValue }) => {
    delete template.binaryTemplate

    var raw = JSON.stringify(template)
    var requestOptions = {
      method: RequestMethods.POST,
      headers: BuildHeader(),
      body: raw,
    }

    const response = await fetch(
      window.extended.MYAPP_API_ENDPOINT + '/Template/insert',
      requestOptions,
    )
    if (!response.ok) {
      return rejectWithValue(await response.text())
    }
    return await response.json()
  },
)

export const CreateTemplate = createAsyncThunk('CreateTemplate', async () => {
  var requestOptions = {
    method: RequestMethods.GET,
    headers: BuildHeader(),
    // body: raw,
    // redirect: "follow",
  }

  const response = await fetch(
    window.extended.MYAPP_API_ENDPOINT + '/Template/generateHtmlTemplate',
    requestOptions,
  )

  const formatttedResponse = await response.json()
  return formatttedResponse
})

export const DeleteTemplateDesign = createAsyncThunk(
  'DeleteTemplateDesign',
  async (id, { rejectWithValue }) => {
    const requestOptions = {
      method: RequestMethods.DELETE,
      headers: BuildHeader(),
    }
    const response = await fetch(
      window.extended.MYAPP_API_ENDPOINT + `/Template/delete?Id=${encodeURIComponent(id)}`,
      requestOptions,
    )
    if (response.status === 409) {
      const body = await response.json()
      return rejectWithValue({ blocked: true, blockedBy: body?.blockedBy, id })
    }
    if (!response.ok) {
      const text = await response.text()
      return rejectWithValue({ blocked: false, message: text, id })
    }
    return id
  },
)

export const CloneTemplate = createAsyncThunk('CloneTemplate', async (templateId) => {
  // First, get the template to clone
  var getRequestOptions = {
    method: RequestMethods.GET,
    headers: BuildHeader(),
  }

  const getResponse = await fetch(
    window.extended.MYAPP_API_ENDPOINT + `/Template/get?Id=${templateId}`,
    getRequestOptions,
  )
  const templateToClone = await getResponse.json()

  // Prepare the cloned template (remove ID and update title)
  const clonedTemplate = {
    ...templateToClone,
    id: '00000000-0000-0000-0000-000000000000', // Will be generated by backend
    title: `${templateToClone.title} (Kopi)`,
  }

  // Insert the cloned template
  var raw = JSON.stringify(clonedTemplate)
  var insertRequestOptions = {
    method: RequestMethods.POST,
    headers: BuildHeader(),
    body: raw,
  }

  const insertResponse = await fetch(
    window.extended.MYAPP_API_ENDPOINT + '/Template/insert',
    insertRequestOptions,
  )
  const formatttedResponse = await insertResponse.json()
  return formatttedResponse
})

const TemplateDesignerState = createSlice({
  name: 'TemplateDesigner',
  initialState,
  reducers: {},
  extraReducers: {
    [GetTemplateDesigns.pending]: (state) => {
      state.isLoading = true
    },
    [GetTemplateDesigns.fulfilled]: (state, action) => {
      state.Templates = _.orderBy(action.payload, ['id'], ['asc'])
    },
    [GetTemplateDesigns.rejected]: (state, action) => {},

    [UpdateTemplateDesign.pending]: (state) => {
      state.isLoading = true
    },
    [UpdateTemplateDesign.fulfilled]: (state, action) => {
      state.Templates = _.orderBy(
        state.Templates.map((x) => (x.id === action.payload.id ? action.payload : x)),
        ['id'],
        ['asc'],
      )
    },
    [UpdateTemplateDesign.rejected]: (state, action) => {},

    [InsertTemplateDesign.pending]: (state) => {
      state.isLoading = true
    },
    [InsertTemplateDesign.fulfilled]: (state, action) => {
      state.Templates = _.orderBy([...state.Templates, action.payload], ['id'], ['asc'])
    },

    [InsertTemplateDesign.rejected]: (state, action) => {},

    [CreateTemplate.pending]: (state) => {
      state.isLoading = true
    },
    [CreateTemplate.fulfilled]: (state, action) => {
      state.EmptyTemplate = action.payload
    },
    [CreateTemplate.rejected]: (state, action) => {},

    [CloneTemplate.pending]: (state) => {
      state.isLoading = true
    },
    [CloneTemplate.fulfilled]: (state, action) => {
      state.Templates = _.orderBy([...state.Templates, action.payload], ['id'], ['asc'])
    },
    [CloneTemplate.rejected]: (state, action) => {},

    [DeleteTemplateDesign.fulfilled]: (state, action) => {
      state.Templates = state.Templates.filter((t) => t.id !== action.payload)
    },
    [DeleteTemplateDesign.rejected]: (state, action) => {},
  },
})

// export const { UpdateStates } = TemplateDesignerState.actions

export default TemplateDesignerState.reducer
